import { useQuery } from "@tanstack/react-query";
import { getClass } from "../../api/apiClasses";
import i18next from "i18next";

export function useGetClass(id) {
    const { isLoading, data: classData, error } = useQuery({
        queryKey: ["classes", id, i18next.language],
        queryFn: () => getClass(id),
        enabled: !!id,
        retry: false,
    });
    return { isLoading, error, classData };
}
